// extracted by mini-css-extract-plugin
export default {"snackbar":"EmailValidationSnackbar_snackbar__W+ulw","content":"EmailValidationSnackbar_content__GYVGc","message":"EmailValidationSnackbar_message__pwQSB"};